<script setup lang="ts">
import HeaderSection from "@components/HeaderSection.vue"
import FooterSection from "@components/FooterSection.vue"
import ErrorDialog from "@components/ErrorDialog.vue"
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <header><HeaderSection></HeaderSection></header>
    <main class="mt-5 mb-8 flex-1 px-4">
      <router-view></router-view>
    </main>
    <footer class="mt-auto"><FooterSection></FooterSection></footer>
    <ErrorDialog></ErrorDialog>
  </div>
</template>
